export default __webpack_public_path__ + "static/media/1.21d49f4a.jpg";